// components/CounterInput/index.jsx

import React from 'react';
import { Box, Button, Typography } from '@mui/material';

const CounterInput = ({ label = "Quantity", value = 0, onChange }) => {

    const handleDecrease = () => {
        if (value > 0) {
            onChange(value - 1);
        }
    };

    const handleIncrease = () => {
        onChange(value + 1);
    };

    return (
        <Box className="field" >
            <Typography sx={{
                color: '#555',
                fontSize: '0.9rem',
                fontFamily: '"Nunito" !important'
            }}>
                {label}
            </Typography>
            <Box
                display="flex"
                alignItems="center"
                border="1px solid #ccc"
                borderRadius="8px"
                overflow="hidden"
            >
                <Button
                    variant="text"
                    onClick={handleDecrease}
                    sx={{ minWidth: 36, padding: 0,lineHeight:'40px' }}
                >
                    -
                </Button>
                <input
                    type="number"
                    value={value}
                    readOnly
                    style={{
                        width: 50,
                        textAlign: "center",
                        border: "none",
                        outline: "none",
                        fontSize: "14px"
                    }}
                />
                <Button
                    variant="text"
                    onClick={handleIncrease}
                    sx={{ minWidth: 36, padding: 0,lineHeight:'40px' }}
                >
                    +
                </Button>
            </Box>
        </Box>
    );
};

export default CounterInput;
